export const ADD_TO_QUERY = 'query/ADD'
export const REMOVE_FROM_QUERY = 'query/REMOVE'
export const CLEAR_FROM_QUERY = 'query/CLEAR'
export const RESET_QUERY = 'query/RESET'
export const CLEAR_QUERY_OF_TYPE = 'query/CLEAR_QUERY_OF_TYPE'

export const ADD_EDUCATION_TO_QUERY = 'query/ADD_EDUCATION'
export const ADD_SKILL_YEARS = 'query/ADD_SKILL_YEARS'
export const ADD_EXPERIENCE_YEARS = 'query/ADD_EXPERIENCE_YEARS'

export const SET_SORT = 'query/SET_SORT'
export const SET_RESULTS = 'query/SET_RESULTS'
export const SET_RESULT_ERROR = 'query/SET_RESULT_ERROR'
export const SET_NO_RESULTS = 'query/SET_NO_RESULTS'
export const SET_SKIP = 'query/SET_SKIP'

export const HAS_RESIDENCE_PERMIT = 'query/HAS_RESIDENCE_PERMIT'
export const HAS_WORK_PERMIT = 'query/HAS_WORK_PERMIT'
export const NO_WORK_PERMIT = 'query/NO_WORK_PERMIT'

export const LOG_IN = 'login/LOG_IN'
export const LOG_OUT = 'login/LOG_OUT'

export const SET_ACTIVE_TAB = 'tab/SET_ACTIVE'
export const SET_ACTIVE_TAB_ONLY = 'tab/SET_ACTIVE_TAB_ONLY'
export const UPDATE_TAB_COLUMN = 'tab/UPDATE_COLUMN'

export const OPEN_MODAL = 'modal/OPEN'
export const CLOSE_MODAL = 'modal/CLOSE'



// WEBPACK FOOTER //
// ./src/store/actionTypes.js